import { Link } from 'react-router-dom';
import { ConditionalRender } from '@ui';
import { BulkNotificationCaseData } from '@/api/apis/communication';
import { failureLabels, organContradictionLabels, successLabels } from './constants';
import { BulkNotificationProps, getBulkNotificationHeading, getCasesParamaters } from './utils';

export const BulkNotificationBody = ({ data, notificationType }: BulkNotificationProps) => {
  const successfulCases: BulkNotificationCaseData[] = JSON.parse(data?.SuccessfulCases || '[]');
  const failedCases: BulkNotificationCaseData[] = JSON.parse(data?.FailedCases || '[]');
  const failedCasesWithCertificationReason: BulkNotificationCaseData[] = JSON.parse(
    data?.FailedCasesWithCertificationReason || '[]',
  );

  const renderCasesList = (cases: BulkNotificationCaseData[]) => {
    return (
      <ul className="list-disc ml-5 text-s-r text-base-20 w-fit">
        {cases.map((caseItem) => (
          <li key={caseItem.caseId} className="mb-0">
            <Link to={`/case/${caseItem.caseId}`} className="underline">
              {caseItem.caseName}
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  const getContent = () => {
    const { hasCertificateFailure, hasRegularFailure, hasSuccess } = getCasesParamaters({ data, notificationType });

    const categoriesCount = [hasCertificateFailure, hasRegularFailure, hasSuccess].filter(Boolean).length;

    if (categoriesCount > 1) {
      return (
        <div className="text-m-m text-base-5">
          <ConditionalRender show={successfulCases.length > 0}>
            <div>{successLabels[notificationType]}:</div>
            {renderCasesList(successfulCases)}
          </ConditionalRender>
          <ConditionalRender show={failedCases.length > 0}>
            <div>{failureLabels[notificationType]}:</div>
            {renderCasesList(failedCases)}
          </ConditionalRender>
          <ConditionalRender show={failedCasesWithCertificationReason.length > 0}>
            <div>{organContradictionLabels[notificationType]}:</div>
            {renderCasesList(failedCasesWithCertificationReason)}
          </ConditionalRender>
        </div>
      );
    }

    return renderCasesList([...successfulCases, ...failedCases, ...failedCasesWithCertificationReason]);
  };

  return (
    <div>
      <div className="text-m-m text-base-5 wrap-break-word line-clamp-2">
        {getBulkNotificationHeading({ data, notificationType })}
      </div>
      {getContent()}
    </div>
  );
};
